import type { Building } from "building-types/building/buildingTypes";
import { makeFloorAreaTakeoffs } from "../generationTools/generateFloorAreaTakeoffsTools";
import memo from "../utils/memo";

function select({
  floorPlates,
  rooms,
  walls,
  planarGraphs,
  roomLevelIndices,
  roomsByLevel,
  levels,
  wallMasses,
  porches,
  settings,
  measurements,
}: Building) {
  return {
    measurements,
    floorPlates,
    rooms,
    walls,
    wallMasses,
    planarGraphs,
    roomLevelIndices,
    levels,
    roomsByLevel,
    porches,
    plansetSettings: settings.planset,
  };
}

function generate({
  measurements,
  rooms,
  walls,
  wallMasses,
  planarGraphs,
  roomLevelIndices,
  roomsByLevel,
  levels,
  porches,
  plansetSettings,
}: ReturnType<typeof select>) {
  const { totalFloorArea, floorAreaTakeoffs } = makeFloorAreaTakeoffs(
    planarGraphs,
    walls,
    wallMasses,
    rooms,
    roomsByLevel,
    levels,
    roomLevelIndices,
    porches,
    plansetSettings,
    measurements,
  );
  return { totalFloorArea, floorAreaTakeoffs };
}

export default memo(select, generate);
